import { render, staticRenderFns } from "./RiskListExpand.vue?vue&type=template&id=09dcf1e0&scoped=true&"
import script from "./RiskListExpand.vue?vue&type=script&lang=js&"
export * from "./RiskListExpand.vue?vue&type=script&lang=js&"
import style0 from "./RiskListExpand.vue?vue&type=style&index=0&id=09dcf1e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dcf1e0",
  null
  
)

export default component.exports